import { apiRequest } from './client';

// Products as the API names them, keyed by the app's module ids.
export const products = [
  ['flights', 'Flights'],
  ['hotels', 'Hotels'],
  ['sightseeing', 'Sightseeing'],
  ['packages', 'Packages'],
  ['transfers', 'Transfers'],
  ['insurance', 'Insurance'],
  ['bus', 'Bus'],
];

// Customer checkout
export const listPromoOffers = (module, signal) =>
  apiRequest(`/api/promo-codes?product=${module}`, { signal });

/**
 * Fare + convenience fee - promo discount. With a payment method, the convenience fee includes that method's
 * transaction fee. A rejected promo code throws ApiError (status 400) with the reason.
 */
export const getPriceQuote = ({ module, subtotal, travellers, promoCode, email, paymentMethod }, token, signal) =>
  apiRequest('/api/pricing/quote', {
    body: { product: module, subtotal, travellers, promoCode: promoCode || null, email: email || null, paymentMethod: paymentMethod || null },
    token,
    signal,
  });

/** Records a promo code used on a booking that has no supplier checkout (flight checkout records its own). */
export const redeemPromoCode = ({ module, subtotal, travellers, promoCode, email, bookingReference }, token) =>
  apiRequest('/api/pricing/redemptions', {
    body: { product: module, subtotal, travellers, promoCode, email, bookingReference },
    token,
  });

// Admin
export const adminListPromoCodes = (token) => apiRequest('/api/admin/promo-codes', { token });
export const adminGetPromoCode = (token, id) => apiRequest(`/api/admin/promo-codes/${id}`, { token });
export const adminCreatePromoCode = (token, promo) => apiRequest('/api/admin/promo-codes', { body: promo, token });
export const adminUpdatePromoCode = (token, id, promo) =>
  apiRequest(`/api/admin/promo-codes/${id}`, { method: 'PUT', body: promo, token });
export const adminDeletePromoCode = (token, id) =>
  apiRequest(`/api/admin/promo-codes/${id}`, { method: 'DELETE', token });

export const adminGetConvenienceFees = (token) => apiRequest('/api/admin/convenience-fees', { token });
export const adminSaveConvenienceFees = (token, fees) =>
  apiRequest('/api/admin/convenience-fees', { method: 'PUT', body: fees, token });

// Transaction fee per payment method (Upi, DebitCard, CreditCard, NetBanking, InternationalCard).
export const adminGetPaymentMethodFees = (token) => apiRequest('/api/admin/payment-method-fees', { token });
export const adminSavePaymentMethodFees = (token, fees) =>
  apiRequest('/api/admin/payment-method-fees', { method: 'PUT', body: fees, token });
